<template>
  <div class="outer-wrapper">
    <div
      :id="ids"
      class="chart-wrapper"
      :style="esize"
    ></div>
  </div>
</template>
<script>
let userToken = localStorage.getItem("current_user_token");
export default {
  name: "oneGoods",
  props: {
    "optionData":{
        type:Object,
        required:false,
        default:function(){
          return {};
        }
    },
    'chart_draw_again':{
      type:Number,
      required:false,
      default:0
    },
    'esize':{
      type:Object,
      required:true,
      default:function(){
        return { height: '430px', width: '700px'};
      }
    },
    'goodsObject':{
        type:Object,
        required:true,
        default:function(){
          return {};
        }
    },

  },
  data() {
    return {
        ids:this.$options.name,
        originData: null,
    };
  },
  mounted() {
    
  },
  mixins: [],
  watch: {
    chart_draw_again: function (val) {
      if (val > 0) {
        this.get_data();
      }
    },
  },
  computed: {
    chartData:function(){
      return this.originData;
    }
  },
  methods: {
    get_data() {
      this.$axios
        .post(this.$url + "/chartdata", {
          askData: this.$options.name,
          optionData: this.optionData,
          userToken: userToken,
          goodsId:this.goodsObject.id
        })
        .then((response) => {
            if(response.data.stat==='ok'){
                this.originData = response.data.res;
                this.drawIt();
            }else{
                console.log('获取数据失败！');
            }
        });
    },
    drawIt() {
      let myChart = this.$echarts.init(document.getElementById(this.ids));
      let timeData = this.chartData.timeData;
      let valueData = this.chartData.valueData;
      let alertAmount = this.goodsObject.alert_amount;
      let option = {
        backgroundColor: "#ffe0ff",
        title: {
          text: "历史库存量统计",
          subtext: this.goodsObject.name,
          left: "center",
          top: "5%",
          textStyle: {
            color: "#888",
            verticalAlign: "top",
          },
        },
        legend: {
          data: ["库存量"],
          bottom:'3%'
        },
        tooltip: {
        trigger: 'axis',
        axisPointer: {
            type: 'cross',
            label: {
                backgroundColor: '#6a7985'
            }
        }
    },
        grid: {
          x: "10%",
          y: "25%",
          x2: "10%",
          y2: "25%",
          borderWidth: 10,
        },
        toolbox: {
          show: true,
          orient: "vertical",
          left: "right",
          top: "center",
          feature: {
            mark: { show: true },
            dataView: { show: true, readOnly: false },
            restore: { show: true },
            saveAsImage: { show: true },
          },
        },
        xAxis: {
          data: timeData,
          name: "时间",
          type: "category",
          boundaryGap:false,
        },
        yAxis: [
          {
            type: "value",
            name: "数量("+this.goodsObject.pit+')',
            splitArea: { show: false },
            max: function (value) {
                return Math.ceil(value.max*0.11)*10;
            },
          },
        ],
        series: [
          {
            name: "库存量",
            type: "line",
            data: valueData,
            itemStyle:{
              color:'#71fc4c',

            },
            endLabel: {
              show:true
            },
            areaStyle: {},
            markLine: {
              data: [{
                  name:'警戒库存',
                  yAxis: alertAmount
              },],
              symbol:['triangle','triangle'],
              silent: false,
              itemStyle:{
                color:'red'
              },
              label:{
                show:true,
                formatter:'{b}:{c}'+this.goodsObject.pit,
                position:'middle',
                color:'rgba(208, 76, 76, 1)'
              }
            },
            markPoint:{
              data:[
                {
                  type:'max',
                  symbol:'pin',
                  symbolSize:[30,40],
                  itemStyle: {
                    color: "rgba(98, 177, 217, 1)"
                  }
                },
                {
                  type:'min',
                  symbol:'arrow',
                  symbolSize:[20,40],
                  itemStyle: {
                    color: "rgba(64, 62, 28, 1)"
                  }
                }
              ]
            }
          },
          
        ],
      };
      myChart.setOption(option);
    },
  },
};
</script>
<style scoped>
.outer-wrapper {
  margin: 0;
  position: relative;
  width:100%;
}
.chart-wrapper {
  border: 1px solid #eeeded;
  border-radius: 3px;
  margin: 0 auto;
}
</style>